<template>
    <UModal
        :close="{ onClick: () => emit('close') }"
    >
        <template #content>
            <product-editor
                ref="productEditorInstance"
                class="bg-base-100 rounded debug-screens"
                :product="product"
                @cancel="() => emit('close')"
                @save="(updatedProduct: Product) => emit('close', updatedProduct)"
            />
        </template>
    </UModal>
</template>

<script setup lang="ts">
import ProductEditor from '@/products/ProductEditor.vue'
import {Product} from '@/products/product.types'

const emit = defineEmits<{ close: [Product?] }>()
defineProps({
    product: {
        type: Object as () => Product,
        required: false
    }
})

</script>

<style scoped>

</style>